import { useState } from "react";
import { getBatch, getSortedCollection } from "sprint-common-web";

import { BucketArchiveItem } from "./BucketArchiveItem";
import { BucketArchiveListingFilters } from "./useBucketArchiveListingFilters";

export const useBucketArchiveListing = () => {
    const [items, setItems] = useState<BucketArchiveItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const saveData = (BucketArchiveItems: BucketArchiveItem[], filters: BucketArchiveListingFilters): void => {
        const sortedItems = getSortedCollection(BucketArchiveItems, filters.sortBy, filters.sortOrder);
        const itemsToDisplay = getBatch(sortedItems, filters.pageSize, filters.page);

        setTotalItems(sortedItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        saveData
    };
};
